import { GetGroupResponseResult } from '@/coreInfrastructureModule/axios/generated/groupManage';
import { IGroupList } from '../interface/groupList';

/**
 * グループ取得のアダプタ
 */
export class GetGroupAdapter {
  /**
   * responseをUI用に変換する
   * @param response - レスポンス
   */
  public static adaptForResponse(response: GetGroupResponseResult): IGroupList {
    return {
      groups: response.data.map((group) => {
        return {
          groupId: group.groupId,
          groupName: group.groupName,
        };
      }),
      pagingOptions: {
        pageSize: response.data.length,
        offset: response.data.length,
        returnCount: response.data.length,
      },
    };
  }
}
